export default "__VITE_ASSET__Ct9VJznV__"